import AvatarPage from "./AvatarPage";

export default AvatarPage;
